<template>
  <v-btn text rounded icon @click="updateTheme">
    <transition name="fade" mode="out-in">
      <v-icon>{{ themeIcon }}</v-icon>
    </transition>
  </v-btn>
</template>

<script>
import { saveDarkTheme } from '@/helpers/theme';

export default {
  computed: {
    themeIcon() {
      return this.$vuetify.theme.dark ? 'nights_stay' : 'wb_sunny';
    },
  },
  methods: {
    updateTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      saveDarkTheme(this.$vuetify.theme.dark);
    },
  },
};
</script>
